<template>
 <div>

  <div class="menu-content" :class="menu">
       <p class="logo logo-menu">Admin</p>
       <ul>
          <li class="nav-item active">
            <a class="nav-link" href="#"><br><span class="sr-only">(página atual)</span></a>
          </li>
          <li class="nav-item"><a class="nav-link" @click="route('motoristas')" href="javascript:void(0)">Motoristas</a></li>
          <li class="nav-item"><a class="nav-link" @click="route('servicos')"   href="javascript:void(0)">Serviços</a></li>
          <li class="nav-item"><a class="nav-link" @click="route('parceiros')"  href="javascript:void(0)">Parceiros</a></li>
          <li class="nav-item"><a class="nav-link" @click="route('promocoes')"  href="javascript:void(0)">Promoções</a></li>
          <li class="nav-item"><a class="nav-link" @click="sair()" href="javascript:void(0)"> Sair</a></li>
        </ul>
  </div>
  <div class="menu-active-mobile">
    <a href="javascript:void(0)" @click="showMenuMobile()">
        <img src="/images/menu.svg" alt="Menu">
    </a>
  </div>
  <notifications group="notify" position="top center"  /> 
 </div>
</template>

<script>
export default {
  name: "MenuBarAdm",
  data:()=>{
    return {
      menu:"",
    }
  },
  methods: {
    route(path) {
      this.$router.push(`/${path}`);
    },
    showMenuMobile(){
         this.menu = "show-menu-mobile";
    },
    sair(){

      this.$cookies.remove(process.env.VUE_APP_TOKEN_ADMIN);
      this.$router.push({name:"login"});

    }
     
  }
};
</script>
 